module.exports = __webpack_public_path__ + "media/images/undraw/mobile_messages-51d619c5a51e00624cf046cfc126d565.png";